import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import {
  BooksHeaderLink,
  BooksHeaderWrapper,
} from "../../../Books/components/BooksHeader/BooksHeader.styles";

const InboundHeader: FC = () => {
  const { t } = useTranslation("common");
  return (
    <BooksHeaderWrapper>
      <BooksHeaderLink title={t("inbound.tabs.shipments")} end to="/inbound">
        {t("inbound.tabs.shipments")}
      </BooksHeaderLink>
      <BooksHeaderLink
        title={t("inbound.shipFromAddresses")}
        end
        to="/inbound/addresses"
      >
        {t("inbound.shipFromAddresses")}
      </BooksHeaderLink>
    </BooksHeaderWrapper>
  );
};

export default memo(InboundHeader);
